export default __webpack_public_path__ + "static/media/cancelIcon.814c369d.svg";